__webpack_require__.p = "/baskin-client2/";